(function () {
  'use strict';

  var latestCartCents = null;
  var latestCart = null; 
  var refreshTimer = null;


  function getTiers(root) {
    var tierEls = root.querySelectorAll('[data-ttp-tier]');
    return Array.prototype.map.call(tierEls, function (el) {
      return {
        el: el,
        threshold: parseFloat(el.getAttribute('data-threshold')),
        reward: el.getAttribute('data-reward') || ''
      };
    });
  }

  function sortedTiers(tiers) {
    return tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
  }

  function findNextTier(cartTotal, tiers) {
    var sorted = sortedTiers(tiers);
    for (var i = 0; i < sorted.length; i++) {
      if (cartTotal < sorted[i].threshold) return sorted[i];
    }
    return null;
  }

  function calculateRawFill(cartTotal, maxThreshold) {
    return Math.min((cartTotal / maxThreshold) * 100, 100);
  }

  /* Formats an amount (given in the shop's base currency) for display,
     converting it into whatever currency the shopper currently has selected
     via the storefront's currency switcher (window.Currency / ACSCurrency),
     with correct symbol, symbol position and decimal/thousands separators.
     Falls back to the shop's default money format, then to naive symbol
     concatenation, if a converter isn't available. */
  function formatCurrencyAmount(amount, currencySymbol) {
    var cents = Math.round(amount * 100);

    if (window.Currency && typeof window.Currency.convert === 'function' &&
        typeof window.Currency.formatMoney === 'function') {
      var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      var displayCurrency = window.Currency.currentCurrency || shopCurrency;
      if (displayCurrency !== shopCurrency) {
        var convertedCents = window.Currency.convert(cents, shopCurrency, displayCurrency);
        var formats = window.Currency.moneyFormats && window.Currency.moneyFormats[displayCurrency];
        var format = formats && (formats.money_format || formats.money_with_currency_format);
        if (format) return window.Currency.formatMoney(convertedCents, format);
      }
    }

    var bodyFormat = document.body && document.body.getAttribute('data-money-format');
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && bodyFormat) {
      return window.Shopify.formatMoney(cents, bodyFormat);
    }

    return (currencySymbol || '£') + amount.toFixed(2);
  }


  function calculateSegmentFill(cartTotal, tiers) {
    if (!tiers.length || cartTotal <= 0) return 0;
    var sorted = sortedTiers(tiers);
    var segmentSize = 100 / sorted.length;
    for (var i = 0; i < sorted.length; i++) {
      if (cartTotal < sorted[i].threshold) {
        var prevThreshold = i === 0 ? 0 : sorted[i - 1].threshold;
        var range = sorted[i].threshold - prevThreshold;
        var progress = range > 0 ? (cartTotal - prevThreshold) / range : 0;
        return i * segmentSize + progress * segmentSize;
      }
    }
    return 100;
  }


  function calculateSpaceAroundFill(cartTotal, tiers) {
    if (!tiers.length || cartTotal <= 0) return 0;
    var sorted = sortedTiers(tiers);
    var N = sorted.length;

    function circlePos(idx) { return ((2 * (idx + 1) - 1) / (2 * N)) * 100; }

    for (var i = 0; i < sorted.length; i++) {
      if (cartTotal < sorted[i].threshold) {
        var prevThreshold = i === 0 ? 0 : sorted[i - 1].threshold;
        var range = sorted[i].threshold - prevThreshold;
        var progress = range > 0 ? (cartTotal - prevThreshold) / range : 0;
        var startPos = i === 0 ? 0 : circlePos(i - 1);
        var endPos = circlePos(i);
        return startPos + progress * (endPos - startPos);
      }
    }
    return 100;
  }

  function updateV4Bar(root, cartTotal) {
    var fill = root.querySelector('.ttp-rewards-v4__fill');
    var message = root.querySelector('.ttp-rewards-v4__message');

    if (!fill || !message) return;

    var tiers = getTiers(root);
    if (!tiers.length) return;

    var maxThreshold = parseFloat(root.getAttribute('data-max-threshold'));
    var currencySymbol =
      root.getAttribute('data-currency-symbol') || '£';

    var allUnlockedMsg =
      root.getAttribute('data-all-unlocked-message') ||
      'All rewards unlocked!';

    var fillMode = root.getAttribute('data-fill-mode');

    var pct;

    if (fillMode === 'space-around') {
      pct = calculateSpaceAroundFill(cartTotal, tiers);
    } else if (fillMode === 'segments') {
      pct = calculateSegmentFill(cartTotal, tiers);
    } else {
      pct = calculateRawFill(cartTotal, maxThreshold);
    }

    fill.style.width = pct + '%';

    var nextTier = findNextTier(cartTotal, tiers);

    if (nextTier) {

      var diff = nextTier.threshold - cartTotal;

      message.innerHTML =
        'Add <strong>' +
        formatCurrencyAmount(diff, currencySymbol) +
        '</strong> more to unlock <strong>' +
        nextTier.reward +
        '</strong>';

    } else {

      message.innerHTML =
        '<strong>' + allUnlockedMsg + '</strong>';

    }

    tiers.forEach(function (t) {
      t.el.setAttribute(
        'data-unlocked',
        cartTotal >= t.threshold ? 'true' : 'false'
      );
    });
  }

  /* ================================================================
    NEW: BUNDLE V4 — quantity-based tier list (Bundle & Save)
    Counts the selected product's quantity in the cart and marks
    tiers via data-unlocked (same convention as the progress bars).
    ================================================================ */
  /* Cart line items (from /cart.js) don't expose product tags, so tags are
     fetched per product handle and cached to avoid refetching on every
     cart refresh. */
  var productTagsCache = {};

  function getProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (productTagsCache[handle]) return productTagsCache[handle];
    var promise = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (product) { return product.tags || []; })
      .catch(function () { return []; });
    productTagsCache[handle] = promise;
    return promise;
  }

  function countProductQtyByTag(cart, tagFilter) {
    if (!cart || !cart.items) return Promise.resolve(0);
    if (!tagFilter) return Promise.resolve(cart.item_count || 0);

    var wantedTags = tagFilter.toLowerCase().split(',').map(function (t) {
      return t.trim();
    }).filter(Boolean);
    if (!wantedTags.length) return Promise.resolve(cart.item_count || 0);

    var handles = cart.items
      .map(function (item) { return item.handle; })
      .filter(function (handle, i, arr) { return handle && arr.indexOf(handle) === i; });

    return Promise.all(handles.map(getProductTags)).then(function (tagLists) {
      var tagsByHandle = {};
      handles.forEach(function (handle, i) {
        tagsByHandle[handle] = (tagLists[i] || []).map(function (t) { return t.toLowerCase().trim(); });
      });

      var sum = 0;
      cart.items.forEach(function (item) {
        var itemTags = tagsByHandle[item.handle] || [];
        var matched = itemTags.some(function (tag) { return wantedTags.indexOf(tag) !== -1; });
        if (matched) sum += item.quantity;
      });
      return sum;
    });
  }

  function getBundleTiers(root) {
    var els = root.querySelectorAll('[data-ttp-bundle-tier]');
    return Array.prototype.map.call(els, function (el) {
      return {
        el: el,
        qty: parseInt(el.getAttribute('data-qty'), 10) || 0,
        discount: el.getAttribute('data-discount') || ''
      };
    }).sort(function (a, b) { return a.qty - b.qty; });
  }

  function paintBundleV4(root, tiers, currentQty) {
    tiers.forEach(function (t) {
      t.el.setAttribute('data-unlocked', currentQty >= t.qty ? 'true' : 'false');
    });
 
    var message = root.querySelector('[data-ttp-bundle-message]');
    if (!message) return;

    var bundleQty = parseInt(root.getAttribute('data-bundle-qty'), 10) || 4;
    var bundlePrice = root.getAttribute('data-bundle-price') || '';
    var bundleSavings = root.getAttribute('data-bundle-savings') || '';
    console.log("bundleSavings",bundleSavings,bundleQty,currentQty);
    if (currentQty >= bundleQty) {
      message.textContent =
        bundleSavings;
    } else {
      var remaining = bundleQty - currentQty;
      message.textContent =
        'ADD ' + remaining + ' MORE TO GET ' + bundlePrice;
    }
  }

  function updateBundleV4(root, cart) {
    var tiers = getBundleTiers(root);
    var bundleTag = root.getAttribute('data-bundle-tag') || '';

    /* Live cart if we have it, otherwise the server-rendered initial qty */
    if (!cart) {
      paintBundleV4(root, tiers, parseInt(root.getAttribute('data-initial-qty'), 10) || 0);
      return;
    }

    countProductQtyByTag(cart, bundleTag).then(function (currentQty) {
      paintBundleV4(root, tiers, currentQty);
    });
  }

  function updateAllBundles(cart) {
    if (cart) latestCart = cart;
    var bundles = document.querySelectorAll('[data-ttp-bundle]');
    Array.prototype.forEach.call(bundles, function (b) {
      updateBundleV4(b, latestCart);
    });
  }


  function updateBar(root, cartTotalCents) {
    if (!root) return;
    var cartTotal = cartTotalCents / 100;

    if (root.classList.contains('ttp-rewards--v4'))
      return updateV4Bar(root, cartTotal);
  }

  function updateAll(cartTotalCents) {
    if (cartTotalCents !== undefined && cartTotalCents !== null) {
      latestCartCents = cartTotalCents;
    }
    var bars = document.querySelectorAll('[data-ttp-rewards]');
    Array.prototype.forEach.call(bars, function (bar) {
      var total = latestCartCents !== null
        ? latestCartCents
        : parseFloat(bar.getAttribute('data-cart-total'));
      updateBar(bar, total);
    });
  }

  function refreshFromCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateAll(cart.total_price);
        updateAllBundles(cart); /* NEW */
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromCart, delay || 150);
  }

  /* ================================================================
    SHARED INFRASTRUCTURE
    ================================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateAll();
      updateAllBundles(null); /* NEW: paints from data-initial-qty */
    });
  } else {
    updateAll();
    updateAllBundles(null); /* NEW */
  }

  var CART_EVENTS = [
    'cart:updated', 'cart:refresh', 'cart:change',
    'cart:item-added', 'cart:build',
    'theme:cart:change', 'theme:cart:added',
    'shopify:section:load',
    'ajaxCart.afterCartLoad', 'cart.requestComplete',
    'liquid-ajax-cart:request-end',
    'slate:cart:added'
  ];
  CART_EVENTS.forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleRefresh(); });
    window.addEventListener(evt, function () { scheduleRefresh(); });
  });

  var CART_URL_RX = /\/cart\/(add|change|update|clear)(\.js|\.json)?/;

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (CART_URL_RX.test(urlStr)) {
        result.then(function () { scheduleRefresh(200); });
      }
      return result;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._ttpUrl = url || '';
      return originalOpen.apply(this, arguments);
    };
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr._ttpUrl && CART_URL_RX.test(xhr._ttpUrl)) {
        xhr.addEventListener('load', function () { scheduleRefresh(200); });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && /\/cart\/(add|change|update)/.test(form.action)) {
      scheduleRefresh(400);
    }
  }, true);

  /* Multi-currency switcher support: the storefront's currency converter
     (window.Currency / ACSCurrency) loads asynchronously and independently
     of cart events, and this theme's currency switcher(s) don't reliably
     fire a listenable event when the shopper changes currency. Instead,
     watch window.Currency.currentCurrency directly and re-render whenever
     it changes (this also covers the converter simply not being ready yet
     on first page load). */
  (function () {
    var lastKnownCurrency = null;
    setInterval(function () {
      var current = window.Currency && window.Currency.currentCurrency;
      if (current && current !== lastKnownCurrency) {
        lastKnownCurrency = current;
        updateAll();
      }
    }, 500);
  })();

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest(
      '[name="add"], [data-add-to-cart], [data-cart-add], ' +
      '[data-cart-remove], [data-cart-change], ' +
      'cart-remove-button, quantity-input, ' +
      'a[href*="/cart/change"], a[href*="/cart/clear"]'
    );
    if (hit) scheduleRefresh(400);
  }, true);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var foundBars = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;

          var bars = [];
          if (node.matches && node.matches('[data-ttp-rewards]')) {
            bars.push(node);
          }
          if (node.querySelectorAll) {
            var inner = node.querySelectorAll('[data-ttp-rewards]');
            for (var k = 0; k < inner.length; k++) bars.push(inner[k]);
          }

          for (var b = 0; b < bars.length; b++) {
            foundBars = true;
            var serverTotal = parseFloat(bars[b].getAttribute('data-cart-total'));
            var total = !isNaN(serverTotal) ? serverTotal : latestCartCents;
            if (total !== null && !isNaN(total)) updateBar(bars[b], total);
          }

          /* NEW: handle re-rendered bundle blocks (e.g. cart drawer re-render) */
          if (node.matches && node.matches('[data-ttp-bundle]')) {
            foundBars = true;
            updateBundleV4(node, latestCart);
          }
          if (node.querySelectorAll) {
            var innerBundles = node.querySelectorAll('[data-ttp-bundle]');
            for (var m = 0; m < innerBundles.length; m++) {
              foundBars = true;
              updateBundleV4(innerBundles[m], latestCart);
            }
          }
        }
      }
      if (foundBars) scheduleRefresh(50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
